import script from "./dizhiform.vue?vue&type=script&setup=true&lang=js"
export * from "./dizhiform.vue?vue&type=script&setup=true&lang=js"

import "./dizhiform.vue?vue&type=style&index=0&id=7d321a00&lang=css"
import "./dizhiform.vue?vue&type=style&index=1&id=7d321a00&lang=scss&scoped=scoped"

import exportComponent from "C:\\Users\\23586\\Desktop\\美国站\\h5\\us-station-number\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d321a00"]])

export default __exports__